export const api = {
  storage: {
    queryColdStorageList: '/bms/queryColdStorage/queryColdStorageList', // 查询冷库列表
    addColdStorage: '/bms/addColdStorage/addColdStorage', // 新增冷库
    updateColdStorage: '/bms/addColdStorage/updateColdStorage', // 修改冷库
    deleteColdStorage: '/bms/addColdStorage/deleteColdStorage', // 删除冷库
    queryColdStorageManager: '/bms/queryColdStorage/queryColdStorageManager', // 查询冷库库管
    queryPersonnelList: '/cms/account/queryResultsByPag.json', // 查询所有的人员信息
    addColdStorageAccount: '/bms/addColdStorage/addColdStorageAccount', // 新增库管
    addConfig: '/bms/ioc/bms/sub/cold/storage/saveBatch.json', // 新增子冷库信息表
    queryConfig: '/bms/ioc/bms/sub/cold/storage/list.json', // 查询子冷库信息表
  },
  platform: {
    queryPlatformList: '/bms/queryRailway/queryRailwayPlatformList', // 查询月台信息
    delPlatformList: '/bms/addRailwayPlatform/deleteRailwayPlatform', // 删除月台信息
    addPlatformList: '/bms/addRailwayPlatform/addRailwayPlatform', // 新增月台信息
    updatePlatformList: '/bms/addRailwayPlatform/updateRailwayPlatform', // 修改月台信息
  },
  getDeviceList: '/bms/device/getDeviceListByPage.json', //查询所有设备
}